import { render, staticRenderFns } from "./CytomineProperties.vue?vue&type=template&id=1dfed640&scoped=true"
import script from "./CytomineProperties.vue?vue&type=script&lang=js"
export * from "./CytomineProperties.vue?vue&type=script&lang=js"
import style0 from "./CytomineProperties.vue?vue&type=style&index=0&id=1dfed640&prod&scoped=true&lang=css"
import style1 from "./CytomineProperties.vue?vue&type=style&index=1&id=1dfed640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfed640",
  null
  
)

export default component.exports